<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>View Hazard/Risk</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content>
  <ng-container>
    <h6>Hazard/Risk</h6>
    <p id="name">{{ hazard.name }}</p>
  </ng-container>

  <ng-container *ngIf="hazard.description">
    <h6>Description</h6>
    <p id="description">{{ hazard.description }}</p>
  </ng-container>

  <ng-container>
    <h6>Significant</h6>
    <p>{{ hazard.significant ? 'Yes' : 'No' }}</p>
  </ng-container>

  <ng-container *ngIf="hazard.status">
    <h6>Status</h6>
    <p id="status">{{ hazard.status }}</p>
  </ng-container>

  <ng-container *ngIf="hazard.ira_likelihood && hazard.ira_severity">
    <h6>Initial Risk Assessment Score</h6>
    <p id="ira_score">
      <span [class]="utils.getSiteRiskStatusTextColor(hazard.ira_score_band ?? utils.getRiskAssessmentText(hazard.ira_likelihood, hazard.ira_severity))">
        {{ hazard.ira_score ?? utils.calculateRiskScore(hazard.ira_likelihood, hazard.ira_severity) }}
      </span>
    </p>
  </ng-container>

  <ng-container *ngIf="hazard.ira_likelihood && hazard.ira_severity">
    <h6>Initial Risk Assessment</h6>
    <p id="ira">
      <span [class]="utils.getSiteRiskStatusTextColor(hazard.ira_score_band ?? utils.getRiskAssessmentText(hazard.ira_likelihood, hazard.ira_severity))">
        {{ hazard.ira_score_band ?? utils.getRiskAssessmentText(hazard.ira_likelihood, hazard.ira_severity) }}
      </span>
    </p>
  </ng-container>

  <ng-container *ngIf="hazard.rra_likelihood && hazard.rra_severity">
    <h6>Residual Risk Assessment Score</h6>
    <p id="rra_score">
      <span [class]="utils.getSiteRiskStatusTextColor(hazard.rra_score_band ?? utils.getRiskAssessmentText(hazard.rra_likelihood, hazard.rra_severity))">
        {{ hazard.rra_score ?? utils.calculateRiskScore(hazard.rra_likelihood, hazard.rra_severity) }}
      </span>
    </p>
  </ng-container>

  <ng-container *ngIf="hazard.rra_likelihood && hazard.rra_severity">
    <h6>Residual Risk Assessment</h6>
    <p id="rra">
      <span [class]="utils.getSiteRiskStatusTextColor(hazard.rra_score_band ?? utils.getRiskAssessmentText(hazard.rra_likelihood, hazard.rra_severity))">
        {{ hazard.rra_score_band ?? utils.getRiskAssessmentText(hazard.rra_likelihood, hazard.rra_severity) }}
      </span>
    </p>
  </ng-container>

  <ng-container *ngIf="hazard.controls.length">
    <h6>Hazard/Risk Controls</h6>
    <p id="controls" *ngFor="let control of hazard.controls; let i = index">
      <ng-container *ngIf="control && control?.control && control?.loc">
        <b>{{ i + 1 }} - {{ control.control }}</b> <br />
        {{ loc_list[control.loc - 1] }}
      </ng-container>
    </p>
  </ng-container>

  <ng-container *ngIf="hazard.reviewer">
    <h6>Reviewer</h6>
    <p id="reviewed-by">
      <a (click)="onUserPublicView(hazard.reviewer.hash)"
         matTooltip="View User Public Profile">
        {{ hazard.reviewer.contact_person }}
      </a>
    </p>
  </ng-container>

  <ng-container *ngIf="hazard.reviewer_date">
    <h6>Review Date</h6>
    <p id="reviewed-date">{{ hazard.reviewer_date * 1000 | date:'medium' }}</p>
  </ng-container>

  <ng-container *ngIf="hazard.last_reviewer_date">
    <h6>Last Review Date</h6>
    <p id="last-reviewed-date">{{ hazard.last_reviewer_date * 1000 | date:'medium' }}</p>
  </ng-container>

  <ng-container *ngIf="hazard?.asset && hazard?.asset?.id">
    <h6>Related Asset</h6>
    <p>
      <a *ngIf="!hide_asset_link; else assetText" (click)="onViewAsset(hazard.asset.id)" matTooltip="View this asset">
        {{ hazard.asset.name }}<span *ngIf="hazard.asset.code"> ({{ hazard.asset.code }})</span>
      </a>

      <ng-template #assetText>
        {{ hazard.asset.name }}<span *ngIf="hazard.asset.code"> ({{ hazard.asset.code }})</span>
      </ng-template>
    </p>
  </ng-container>

  <ng-container>
    <h6>Created By</h6>
    <p id="created-by">
      <a (click)="onUserPublicView(hazard.created_by_hash)"
         matTooltip="View User Public Profile">
        {{ hazard.created_by_name }}
      </a>
    </p>
  </ng-container>

  <ng-container *ngIf="hazard.files">
    <h6>Files</h6>
    <app-files-list
      id="files"
      [files]="hazard.files"
      [view]="true">
    </app-files-list>
  </ng-container>
</mat-dialog-content>
